declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '1136780540633633'
let initialized = false

function loadPixelScript() {
  if (initialized) return
  initialized = true

  // Setup fbq queue function (standard Meta Pixel snippet)
  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = !0
  n.version = '2.0'
  n.queue = []

  // Queue init + PageView immediately (the queue will be processed when the script loads)
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  // Load the actual fbevents.js script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Add noscript image fallback
  const noscript = document.createElement('img')
  noscript.height = 1
  noscript.width = 1
  noscript.style.display = 'none'
  noscript.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(noscript)
}

export function initMetaPixel() {
  loadPixelScript()
}

export function trackMetaEvent(
  eventName: string,
  params?: Record<string, any>,
) {
  if (typeof window.fbq === 'function') {
    if (params) {
      window.fbq('track', eventName, params)
    } else {
      window.fbq('track', eventName)
    }
  }
}
